import React, { useState } from 'react'
import './BottomRightButton.css'
import { getEnv } from '../config/env'

const BottomRightButton = () => {
  const [isHovered, setIsHovered] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isRedacting, setIsRedacting] = useState(false)

  const handleFetchRequest = async () => {
    setIsLoading(true)
    try {
      let response = await window.PDR.api.get(
        `${getEnv('REACT_APP_AI_INSIGHTS_BASE_URL')}/conversation/batch_archive`
      )
      console.log('Batch archive response:', response)
      let evals_response = await window.PDR.api.get(
        `${getEnv('REACT_APP_AI_INSIGHTS_BASE_URL')}/evals_v2`
      )
      console.log('Evals v2 response:', evals_response)
    } catch (error) {
      console.error('Error fetching data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleRedactAll = async () => {
    setIsRedacting(true)
    try {
      let response = await window.PDR.api.post(
        `${getEnv('REACT_APP_AI_INSIGHTS_BASE_URL')}/chat_turns/redact_all`,
        {}
      )
      console.log('Redact all response:', response)
    } catch (error) {
      console.error('Error redacting:', error)
    } finally {
      setIsRedacting(false)
    }
  }

  return (
    <div
      className="bottom-right-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}>
      {isHovered && (
        <>
          <one-ux-button
            class="bottom-right-button"
            label={isRedacting ? 'Redacting...' : 'Redact All'}
            purpose="cautious"
            weight="normal"
            state="default"
            disabled={isRedacting}
            onClick={handleRedactAll}>
            <one-ux-icon icon="lock" slot="start" set="default"></one-ux-icon>
          </one-ux-button>
          <one-ux-button
            class="bottom-right-button"
            label={isLoading ? 'Loading...' : 'Batch Archive'}
            purpose="notice"
            weight="normal"
            state="default"
            disabled={isLoading}
            onClick={handleFetchRequest}>
            <one-ux-icon icon="archive" slot="start" set="default"></one-ux-icon>
          </one-ux-button>
        </>
      )}
    </div>
  )
}

export default BottomRightButton
